var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"bar","height":"350","options":_vm._chartOptions,"series":_vm._series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }